import { render, staticRenderFns } from "./BusinessAndTechnology.vue?vue&type=template&id=0dd1f6aa&scoped=true&"
import script from "./BusinessAndTechnology.vue?vue&type=script&lang=js&"
export * from "./BusinessAndTechnology.vue?vue&type=script&lang=js&"
import style0 from "./BusinessAndTechnology.vue?vue&type=style&index=0&id=0dd1f6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd1f6aa",
  null
  
)

export default component.exports